import React, { useEffect, useState } from "react";
import { Table, Row, Col, Input, Button } from "antd";
import axios from "axios";
import moment from "moment";
import { BaseUrl } from "../Constants/Constants";
import "./EventUserResponseReport.css";


const EventUserResponseReport = () => {
  const [loading, setLoading] = useState(false);
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchEmployee, setSearchEmployee] = useState("");
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const res = await axios.get(
          `${BaseUrl}event-management/get-user-response-report`,  
          { withCredentials: true }
        );

        if (Array.isArray(res.data?.data)) {
          setAllData(res.data.data);
          setFilteredData(res.data.data);
        } else {
          setAllData([]);
          setFilteredData([]);
        }
      } catch (err) {
        console.error("Error fetching event response data:", err);
        setAllData([]);
        setFilteredData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  useEffect(() => {
    let filtered = allData;

    if (searchEmployee) {
      filtered = filtered.filter((item) =>
        item?.user?.username
          ?.toLowerCase()
          .includes(searchEmployee.toLowerCase())
      );
    }

    setFilteredData(filtered);
  }, [searchEmployee, allData]);

  const downloadCSV = () => {
    if (filteredData.length === 0) return;

    const headers = [
      "S.No",
      "Employee Name",
      "Email",
      "Event Name",
      "Event Topic",
      "Event Type",
      "Mandatory",
      "Response",
      // "Comments",
    ];

    const rows = filteredData.map((row, index) => [
      index + 1,
      row.user?.username || "",
      row.user?.email || "",
      row.event?.main_name || "",
      row.event?.topic || "",
      row.event?.type || "",
      row.event?.mandatory === true ? "Yes" : row.event?.mandatory === false ? "No" : "N/A",
      row.response || "",
      row.comments || "",
      row.created_at
        ? moment(row.created_at).format("DD-MM-YYYY HH:mm:ss")
        : "N/A",
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers.join(","), ...rows.map((r) => r.join(","))].join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");

    const timestamp = new Date().toISOString().replace(/[:.]/g, "-");

    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `Event_User_Response_Report_${timestamp}.csv`);
    document.body.appendChild(link);
    link.click();
  };

  // ===========================
  // TABLE COLUMNS
  // ===========================
  const columns = [
    {
      title: "S.No",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Employee Name",
      dataIndex: ["user", "username"],
      key: "username",
    },
    {
      title: "Email",
      dataIndex: ["user", "email"],
      key: "email",
    },
    {
      title: "Event Name",
      dataIndex: ["event", "main_name"],
      key: "main_name",
    },
    {
      title: "Topic",
      dataIndex: ["event", "topic"],
      key: "topic",
    },
    {
      title: "Event Type",
      dataIndex: ["event", "type"],
      key: "type",
    },
    {
      title: "Mandatory",
      key: "mandatory",
      render: (_, record) =>
        record.event?.mandatory === true
          ? "Yes"
          : record.event?.mandatory === false
          ? "No"
          : "N/A",
    },
    {
      title: "Response",
      key: "response",
      render: (_, record) => record.response === true ? "Accepted" : record.response === false ? "Rejected" : "N/A",
    }
  ];

  return (
    <div className="scoresMainDiv">

      <div className="eur-report-header">
         <h2>Event User Response Report</h2>
  <Input
    placeholder="Search by Employee Name"
    className="searchInput"
    onChange={(e) => setSearchEmployee(e.target.value)}
  />

  <Button type="primary" className="downloadBtn" onClick={downloadCSV}>
    Download Report
  </Button>
</div>


      {/* Table */}
      <Table
        columns={columns}
        dataSource={filteredData}
        loading={loading}
        rowKey={(record) => record.event_response_id}
        pagination={{
          position: ["bottomCenter"],
          showSizeChanger: false,
        }}
      />
    </div>
  );
};

export default EventUserResponseReport;
